import {
    Box,
    FormControl,
    Text,
    FormLabel,
    Grid,
    GridItem,
    Input,
    Stack,
    Button,
    Image,
} from '@chakra-ui/react'
import AdminBreadcrumb from '../../components/AdminBreadcrumb'
import AdminBlockCard from '../../components/AdminBlockCard'
import { useState, useEffect } from 'react'
import { GoPlus } from 'react-icons/go'
import { useForm } from 'react-hook-form'
import { postRequest } from '../../services/base.service'
import { serialize } from 'object-to-formdata'
import { useToast } from '@chakra-ui/react'
import { useDispatch } from 'react-redux'
import {
    setCurrentPageHeading,
} from '../../redux/common/commonActions'
import { useNavigate } from 'react-router-dom'

const breadCrumb = [
    { label: 'Dashboard', isCurrentPage: false, link: '/admin/dashboard' },
    { label: 'Product Category List', isCurrentPage: false, link: '/admin/product-category-list' },
    { label: 'Add Product Category', isCurrentPage: true },
]

const AddProductCategory = () => {

    const dispatch = useDispatch()
    const {
            register,
            handleSubmit,
            control,
            watch,
            formState: { errors },
        } = useForm({
            defaultValues: {
                name: '',
                image: null,
            },
    })
    const [productCategoryFormError, setProductCategoryFormError] = useState(null)
    const [image, setImage] = useState(null)
    const [isAdding, setIsAdding] = useState(false)
    const [ImageFile, setImageFile] = useState(null)
    const toast = useToast()
    const navigate = useNavigate()

    useEffect(() => {
                dispatch(setCurrentPageHeading('Add Product Category'))
    }, [])

    const browseImage = (e) => {
		if (e.target.files.length > 0) {
			setImageFile(e.target.files[0])
			setImage(URL.createObjectURL(e.target.files[0]))
		}
	}

    const handleAddProductCategory = (data) => {
        setIsAdding(true)
        postRequest(
            `admin/categories`,
            objectToFormData({
                ...data,
                image: ImageFile,
            })
        )
            .then((res) => {
                toast({
                    title: 'Saved Successfully',
                    description: res.message,
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                })
                setIsAdding(false)
                // window.location.reload();
                navigate('/admin/product-category-list')
            })
            .catch((err) => {
                console.log('ERR: ', err)
                toast({
                    title: 'Something Went Wrong!!!',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                })
                setProductCategoryFormError(err.response?.data?.errors)
                setIsAdding(false)
            })
    }

    const objectToFormData = (data) => {
        const object = data
        const formData = serialize(object, { indices: true })
        return formData
    }

    return (
            <>
                <AdminBreadcrumb items={breadCrumb} />
                <Box py={7}>
                                <AdminBlockCard title={'Add Product Category'}>
                                    <Box
                                        pt={'5'}
                                        pb={'8'}
                                        as="form"
                                        onSubmit={handleSubmit(handleAddProductCategory)}
                                    >
                                        <Grid
                                            templateColumns={[
                                                'repeat(1, 1fr)',
                                                'repeat(1, 1fr)',
                                                'repeat(1, 1fr)',
                                                'repeat(4, 1fr)',
                                            ]}
                                            mt={6}
                                            gap={6}
                                        >
                                            <GridItem colSpan={3}>
                                                <Stack gap={2}>
                                                    <FormControl>
                                                        <FormLabel htmlFor="name">Product Category Name</FormLabel>
                                                            <Input
                                                                id="name"
                                                                type="text"
                                                                placeholder={'Enter product category name'}
                                                                borderColor={'gray.300'}
                                                                size={'lg'}
                                                                {...register('name', {
                                                                    required: true,
                                                                })}
                                                            />     
                                                                <Text fontSize="sm" color="red.500">
                                                                    {errors.name?.type === 'required' &&
                                                                        'Product Category Name is required'}
                                                                </Text>
                                                                {productCategoryFormError?.name && (
                                                                    <Text fontSize="sm" mt="2" color="red.500">
                                                                        {productCategoryFormError?.name[0]}
                                                                    </Text>
                                                                )}                                                                               
                                                    </FormControl>
                                                </Stack>
                                            </GridItem>
                                            <GridItem>
                                                <Stack spacing={5}>
                                                    <FormControl>
                                                        <FormLabel>Product Category Image</FormLabel>
                                                        <Box
                                                            display={'block'}
                                                            as="label"
                                                            borderWidth={'1px'}
                                                            borderStyle={'1px'}
                                                            borderColor={'gray.400'}
                                                            htmlFor="browseImage"
                                                            pos={'relative'}
                                                            w={'160px'}
                                                            h={'160px'}
                                                            style={{
                                                                cursor: 'pointer',
                                                                '& > .label': {
                                                                    display: 'none',
                                                                },
                                                                '&:hover > .label': {
                                                                    display: 'block',
                                                                },
                                                            }}
                                                        >
                                                            {image && (
                                                                <Image
                                                                    src={image ? image : null}
                                                                    alt={''}
                                                                    w={'100%'}
                                                                    h={'100%'}
                                                                    objectFit={'contain'}
                                                                />
                                                            )}
                                                            <Input
                                                                name="image"
                                                                zIndex={'-99999'}
                                                                opacity={'0'}
                                                                type={'file'}
                                                                id={'browseImage'}
                                                                onChange={browseImage}
                                                                accept={'image/*'}
                                                                isRequired={'true'}
                                                            />
                                                            <Text
                                                                as="span"
                                                                className={'label'}
                                                                pos={'absolute'}
                                                                top={'50%'}
                                                                left={'50%'}
                                                                fontSize={'12px'}
                                                                display={'block'}
                                                                whiteSpace={'nowrap'}
                                                                px={'2'}
                                                                py={'1'}
                                                                rounded={'full'}
                                                                color={'white'}
                                                                bg={'blue.500'}
                                                                textAlign={'center'}
                                                                textTransform={'uppercase'}
                                                                transform={'translate(-50%, -50%)'}
                                                            >
                                                                Select Image
                                                            </Text>
                                                        </Box>
                                                    </FormControl>
                                                </Stack>
                                            </GridItem>
                                        </Grid>
                                        <Box textAlign={'left'} mt={'3'}>
                                            <Button
                                                isLoading={isAdding}
                                                loadingText={'ADDING...'}
                                                type={'submit'}
                                                size={'lg'}
                                                variant={'brand'}
                                                leftIcon={<GoPlus />}
                                            >
                                                ADD &nbsp;
                                            </Button>
                                        </Box>
                                    </Box>

                                </AdminBlockCard>
                </Box>
            </>
    )

}

export default AddProductCategory